import { render, staticRenderFns } from "./TextboxButtonQuestion.vue?vue&type=template&id=229458f7&scoped=true&"
import script from "./TextboxButtonQuestion.vue?vue&type=script&lang=js&"
export * from "./TextboxButtonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TextboxButtonQuestion.vue?vue&type=style&index=0&id=229458f7&prod&scoped=true&lang=css&"
import style1 from "./TextboxButtonQuestion.vue?vue&type=style&index=1&id=229458f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229458f7",
  null
  
)

export default component.exports